import Router from 'next/router';
import React, { useEffect, useState } from 'react';

import Table from '@/src/shared/components/Table';
import { convertMomentToDate } from '@/utils/dateTimeHelpers';

const columns = [
  {
    title: 'Position',
    dataIndex: 'Title',
    key: 'TITLE',
    sorter: (a, b) => {
      return a.Title > b.Title ? 1 : -1;
    },
  },
  {
    title: 'Division',
    dataIndex: 'DivDesc',
    sorter: (a, b) => {
      return a.DivDesc > b.DivDesc ? 1 : -1;
    },
  },
  {
    title: 'Posted',
    dataIndex: 'DatePosted',
    render: data => convertMomentToDate(data),
    sorter: (a, b) => {
      return new Date(a.DatePosted) > new Date(b.DatePosted) ? 1 : -1;
    },
  },
];
const index = ({ data }) => {
  const [postings, setPostings] = useState([]);

  useEffect(() => {
    setPostings(
      data.filter(posting => {
        return posting.AvailableToWeb === 'Y';
      })
    );
  }, [data]);

  return (
    <Table
      columns={columns}
      dataSource={postings}
      pagination={false}
      rowKey="JobId"
      rowClassName="ant-table-row--clickable"
      onRow={record => {
        return {
          onClick: () => {
            Router.push(
              `/about/apcia-careers/${record.JobId}`,
              `/about/apcia-careers/${record.JobId}`
            );
          },
        };
      }}
    />
  );
};

export default index;
